import { render } from "./RoundButton.vue?vue&type=template&id=7acadef4&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"

import "./RoundButton.vue?vue&type=style&index=0&id=7acadef4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7acadef4"

export default script